export const KoLocale = {
    page: {
        txtTitle: 'UNVOX | 보컬을 즉시 제거',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'unvox 로고',
        },
        action: {
            txtBack: '뒤로',
            txtRetry: '다시 시도',
            txtStartOver: '처음부터',
        },
        job: {
            txtCheckingStatus: '작업 상태 확인 중',
            txtIdLabel: '작업 ID',
        },
        footer: {
            linkPrivacyPolicy: '개인정보 처리방침',
            linkTerms: '약관',
            linkRefunds: '환불',
            linkSupport: '지원',
            txtAllRightsReserved: '모든 권리 보유.',
            txtBugReportsAndFeatures: '버그 신고 및 기능 요청',
        },
        share: {
            title: 'UNVOX | 원클릭 보컬 제거',
            text: '좋아하는 노래를 손쉽게 노래방용 반주로 바꿔보세요!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: '원클릭 보컬 제거',
            txtHeroSubtitle: '내 트랙 또는 YouTube에서 즉시 반주 생성',
            txtInputTypeLabel: '입력 유형',
            txtInputTypeFile: '오디오 파일 업로드',
            txtInputTypeYoutube: 'YouTube 링크',
            txtInputFilePick: '파일 선택',
            txtInputFileSub: '일반 오디오 형식 ({{formats}}), 최대 {{size}} MB.',
            txtPreviewAction: '보컬 제거',
            txtPreviewFailed: '알 수 없는 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            txtUploadSelectFile: '아직 파일이 선택되지 않았습니다',
            txtYoutubeLabel: 'YouTube URL',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: '공개 YouTube 링크를 붙여넣으세요.',
            txtYoutubeMissing: 'YouTube URL을 붙여넣어 주세요.',
            txtYoutubeInvalid: '유효한 YouTube URL을 입력하세요.',
            txtYoutubeTooLong: '이 영상은 15분보다 깁니다. 더 짧은 영상을 선택하세요.',
            txtCheckoutUploadFailed: '업로드에 실패했습니다. 다시 시도해 주세요.',
            txtUploadMissing: '업로드 전에 파일을 선택하세요.',
            txtFileTypeInvalid: '지원되지 않는 파일 형식입니다. 오디오 파일을 업로드하세요 (예: {{formats}}).',
            txtFileTooLarge: '파일이 너무 큽니다. 최대 크기는 {{size}} MB입니다.',
        },
        previewJob: {
            txtUnavailableTitle: '미리보기를 만들 수 없습니다',
            txtUnavailableBody: '알 수 없는 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            txtPreparingTitle: '미리보기 준비 중',
            txtPreparingBody: '최대 2분 정도 걸릴 수 있습니다',
        },
        payment: {
            txtUnavailableTitle: '미리보기를 만들 수 없습니다',
            txtUnavailableBody: '알 수 없는 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            txtPreparingTitle: '미리보기 준비 중',
            txtCheckoutCancelledBody: '요금이 청구되지 않았습니다. 언제든지 다시 시도할 수 있습니다.',
            txtTrackPreviewLabel: '트랙 미리보기',
            txtTrackPreviewHelper: '이 미리보기는 평가용 15초 클립입니다',
            txtEmailLabel: '이메일 주소',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: '다운로드 링크 전달을 위해 사용됩니다.',
            txtCheckoutAction: '{{price}}에 보컬 제거',
            txtCheckoutActionFallback: '보컬 제거',
            txtCheckoutFailed: '결제를 시작할 수 없습니다. 다시 시도해 주세요.',
            txtInvalidEmail: '유효한 이메일 주소를 입력하세요.',
        },
        processing: {
            txtMissingTitle: '작업 id 누락',
            txtMissingBody: '이 페이지에는 작업 id가 필요합니다. 새 미리보기를 시작하세요.',
            txtMissingAction: '업로드로 돌아가기',
            txtStatusFailed: '작업 상태를 가져오지 못했습니다. 다시 시도해 주세요.',
            txtErrorTitle: '문제가 발생했습니다',
            txtSupportAction: '지원팀 문의',
            txtConfirmingTitle: '결제 확인 중',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: '업데이트 확인 중',
            txtWorkingTitle: '전체 트랙 처리 중',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: '다른 작업 시작',
            txtReadyTitle: '다운로드 준비 완료',
            txtReadyBody: '인스트루멘털 파일이 다운로드 준비되었습니다.',
            txtDownloadAction: '다운로드',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: '다른 작업 시작',
        },
        invalidJob: {
            txtTitle: '잘못된 작업 id',
            txtBody: '해당 작업을 찾을 수 없습니다. 새 업로드를 시작하세요.',
            txtAction: '처음부터',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: '지원',
            txtTitle: '지원팀 문의',
            txtLastUpdatedLabel: '최종 업데이트',
            txtLastUpdatedDate: '2026년 2월 9일',
            txtSectionEmailTitle: '이메일',
            txtSectionEmailBodyPrefix: '다음 주소로 이메일 주세요',
            txtSectionIncludeJobIdTitle: '작업 ID를 포함해 주세요',
            txtSectionIncludeJobIdBody: '작업을 빠르게 찾을 수 있도록 작업 ID를 포함해 주세요. 결제한 경우 결제 시 사용한 이메일도 함께 알려주세요.',
            txtSectionBugReportsTitle: '버그 신고',
            txtSectionBugReportsBody: '푸터 링크를 통해 버그 신고 및 기능 요청도 보낼 수 있습니다.',
        },
        bugReportsFeatures: {
            txtEyebrow: '피드백',
            txtTitle: '버그 신고 및 기능 요청',
            txtSubtitle: 'UNVOX는 아직 초기 단계입니다. 문제가 있거나 아이디어가 있다면 보내주세요. 명확한 보고가 수정 배포를 가장 빠르게 만듭니다.',
            txtWhatToIncludeTitle: '포함할 내용',
            txtChecklistExpectedVsActual: '기대한 결과와 실제 결과',
            txtChecklistSteps: '재현 단계 (1, 2, 3)',
            txtChecklistBrowserOs: '브라우저와 OS',
            txtChecklistJobId: '작업 ID (업로드 관련인 경우)',
            txtTipTitle: '팁',
            txtTipBody: '이메일로 보내는 경우, 받은 전달 메일에 직접 답장하여 템플릿을 붙여넣을 수 있습니다.',
            txtTemplateTitle: '복사-붙여넣기 템플릿',
            txtTemplateBody: '버그 신고 / 기능 요청\n\n유형: bug | feature\n요약:\n\n세부 내용:\n- 발생한 일:\n- 기대한 결과:\n- 재현 단계:\n  1.\n- 브라우저/OS:\n\n선택 사항:\n- 작업 ID:\n- YouTube URL:\n- 스크린샷/동영상:\n',
            txtTemplatePageLabel: '페이지',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: '템플릿 복사',
            txtCopyActionCopied: '복사됨',
            txtCopyActionFailed: '복사 실패',
            txtCopyHelpFailed: '클립보드 접근이 차단되었습니다. 위 텍스트를 선택해 수동으로 복사할 수 있습니다.',
            txtCopyHelpIdle: '여기의 내용은 자동 전송되지 않습니다. 이 페이지는 좋은 보고서 작성을 도와줍니다.',
        },
    },
};
